import { memo } from 'react';
import { styled } from '@mui/material';

const StyledSpan = styled('span')(
  ({ theme }) => `
  color: ${theme.palette.error.main} !important;
`,
);

export interface RequiredTextProps {
  children?: React.ReactNode;
  text?: string;
}

const RequiredText: React.FC<RequiredTextProps> = memo((props: RequiredTextProps) => (
  <>
    {props.children ?? props.text}&nbsp;<StyledSpan>*</StyledSpan>
  </>
));

export default RequiredText;
